import { useCurrentStateAndParams } from "@uirouter/react";
import styled from "styled-components";

import { Box } from "@similarweb/ui-components";

import { ChartDelimiter } from "app/components/React/Charts/Common/ChartDelimiter";
import {
    getInitialContext,
    SocialTrafficContext,
} from "app/pages/website-analysis/social-overview/socialTraffic/context";

import { Chart } from "./Chart";
import { Cta } from "./Cta";
import { Legends } from "./Legends";
import { SubTitle } from "./SubTitle";
import { Title } from "./Title";

const Container = styled(Box)`
    width: 100%;
    border-radius: 6px;
    display: flex;
    flex-direction: column;
    height: auto;
`;

const ContentContainer = styled.div`
    padding: 20px 20px 0 20px;
`;

const HeaderContainer = styled.div`
    padding: 20px;
`;

const SocialTraffic = ({ getCtaLink, unlockHook = null, hideFooter = false }) => {
    const { params } = useCurrentStateAndParams();
    return (
        <Container data-automation="social-traffic">
            <SocialTrafficContext.Provider value={getInitialContext(params)}>
                <HeaderContainer>
                    <Title />
                    <SubTitle />
                </HeaderContainer>
                <ChartDelimiter />
                <ContentContainer>
                    <Legends />
                    <Chart />
                </ContentContainer>
                <ChartDelimiter />
                {hideFooter ? null : (
                    <Cta
                        getCtaLink={getCtaLink}
                        unlockHook={unlockHook}
                    />
                )}
            </SocialTrafficContext.Provider>
        </Container>
    );
};

export default SocialTraffic;
